import { useState } from 'react';

export default function useModalState(): [boolean, () => void] {
  const [showModal, setShowModal] = useState<boolean>(false);
  const toggleShowModal = () => setShowModal(!showModal);
  return [
    showModal,
    toggleShowModal,
  ]
};